define('specific/mosaic/models/RowModel', [

], function() {

    var MosaicModel = Backbone.Model.extend({
        defaults: {
            type: "rowview",
            viewId: "",
            rowDatas: [],
            isReady: false
        }
    });

    return MosaicModel;
});
